export const GridinRow = {
  display: "flex",
  padding: 0,
  paddingTop: 8,
  paddingLeft: 8,
};

export const GridLabel = {
  paddingRight: 5,
};

export const GridinRowsWithSpace = {
  display: "flex",
  justifyContent: "space-between",
};

export const labelStyle = {
  marginBottom: "23px",
};

export const labelDataGridStyles = {
  margin: "10px 0",
};

export const GridInRowsJustifyEnd = {
  display: "flex",
  justifyContent: "end",
};
